import { createAction, props } from '@ngrx/store';
import { GlobalMessage, GlobalMessageType } from '@boels/models';
export const addMessage = createAction(
  '[Global-message] Add a Message',
  props<{ message: GlobalMessage }>(),
);

export const removeMessage = createAction(
  '[Global-message] Remove a Message',
  props<{ messageType: GlobalMessageType; index: number }>(),
);

export const removeMessagesByType = createAction(
  '[Global-message] Remove messages by type',
  props<{ messageType: GlobalMessageType }>(),
);
